// extracted by mini-css-extract-plugin
export default {"root":"PageKidE_root__8TQjl","inner":"PageKidE_inner__nC914","content":"PageKidE_content__496LI","back":"PageKidE_back__71kSq"};